import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { SpecificationConfirmClaimsService } from '@/domains/specification/services/specification-confirm-claims-service';
import { ref } from 'vue';
import { useDisposes } from '@telecom/shared/composables/use-disposes';
import type { SpecificationConfirmClaimsData, SpecificationConfirmClaimsState } from '@/domains/specification/types/specification-confirm-claims';
import { createSharedComposable } from '@vueuse/core';
import { CurrentTaskService } from '@/services/current-task/current-task-service';
import { SharePageService } from '@/services/share-page/share-page-service';

export const useSpecificationConfirmClaimsService = createSharedComposable(() => {
    const service = injectService<SpecificationConfirmClaimsService>(SpecificationConfirmClaimsService);
    const currentTaskService = injectService<CurrentTaskService>(CurrentTaskService);
    const sharePageService = injectService<SharePageService>(SharePageService);
    const { disposes } = useDisposes();

    // 状态响应式引用
    const serviceState = ref<SpecificationConfirmClaimsState>(service.getState());

    // 订阅状态变更
    disposes.push(
        service.onStateChange(state => (serviceState.value = state)),
    );

    // 包装服务方法
    async function init(force?: boolean) {
        await sharePageService.initialize();
        await service.init(currentTaskService.taskId, force);
    }

    function patchFormData(payload: Partial<SpecificationConfirmClaimsData>) {
        service.patchFormData(payload);
    }

    async function submit(switchStep?: boolean) {
        await service.submit(switchStep);
    }

    async function regenerate() {
        await service.regenerate();
    }

    return {
        serviceState,
        init,
        patchFormData,
        submit,
        regenerate,
    };
});
